<mat-card class="trinta-card mb-25 bg-white border-none d-block chart-card">
  <mat-card-header>
    <mat-card-title>
      <h5 class="mt-0 mb-0">DUS por Rango de Vencimiento</h5>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="chart-wrapper">
      <div class="donut-container">
        <div id="control_dus_vencimiento_pie_chart"></div>
        <div class="donut-center" *ngIf="total > 0">
          <span class="total-number">{{ total }}</span>
          <span class="total-label">DUS</span>
        </div>
      </div>
      <div class="legend-container" *ngIf="legendItems.length > 0">
        @for (item of legendItems; track item.label) {
        <div class="legend-item">
          <span class="legend-dot" [style.background-color]="item.color"></span>
          <span class="legend-label">{{ item.label }}</span>
          <span class="legend-value">{{ item.value }}</span>
          <span class="legend-percent">({{ item.percent }}%)</span>
        </div>
        }
      </div>
    </div>
  </mat-card-content>
</mat-card>